import './App.css';
import supabase from './supabase';
import Header from './components/Header';
import Form from './components/Form';
import QuoteList from './components/QuoteList';
import Categories from './components/Categories';
import Loader from './components/Loader';
import { useState, useEffect } from 'react';
/*const originalQuotes = [
	{
		id: 1,
		text: 'What does not kill you, makes you stronger',
		author: 'Friedrich Nietzsche',
		source:
			'https://news.northwestern.edu/stories/2019/10/science-proves-that-what-doesnt-kill-you-makes-you-stronger/',
		category: 'strenth',
		like: 0,
		dislike: 0,
		createdIn: 2024,
	},
	{
		id: 2,
		text: 'Develop success from failures. Discouragement and failure are two of the surest stepping stones to success.',
		source: 'https://www.brainyquote.com/quotes/dale_carnegie_130712',
		author: 'Dale Carnegie',
		category: 'success',
		like: 0,
		dislike: 0,
		createdIn: 2024,
	},
	{
		id: 3,
		text: 'A new command I give you: Love one another. As I have loved you, so you must love one another.',
		source:
			'https://www.biblegateway.com/passage/?search=John%2013%3A34-35&version=NIV',
		author: 'Jesus Christ',
		category: 'love',
		like: 0,
		dislike: 0,
		createdIn: 2024,
	},
];*/

function App() {
	const [showForm, setShowForm] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [quotes, setQuotes] = useState([]);
	const [currentCategory, setCurrentCategory] = useState('all');
	useEffect(
		function () {
			async function getQuotes() {
				setIsLoading(true);
				let query = supabase.from('quotes').select('*');
				if (currentCategory !== 'all') {
					query = query.eq('category', currentCategory);
				}
				let { data: quotes, error } = await query;
				if (!error) setQuotes(quotes);
				else alert('Error');
				setIsLoading(false);
			}
			getQuotes();
		},
		[currentCategory]
	);
	return (
		<>
			<Header
				showForm={showForm}
				setShowForm={setShowForm}
			/>
			{showForm ? (
				<Form
					setQuotes={setQuotes}
					setShowForm={setShowForm}
				/>
			) : null}
			<main className='main'>
				<Categories setCurrentCategory={setCurrentCategory} />
				{isLoading ? (
					<Loader />
				) : (
					<QuoteList
						quotes={quotes}
						setQuotes={setQuotes}
					/>
				)}
			</main>
		</>
	);
}

export default App;
